enum SortDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export default SortDirectionEnum;
